<form [formGroup]="formGroup" class="flex flex-col">
  <div>
    <mat-form-field color="primary" class="w-full">
      <mat-label>New Password </mat-label>
      <input
        matInput
        formControlName="password"
        placeholder="New Password"
        [type]="showPassword$() ? 'text' : 'password'"
        autocomplete="current-password"
      />

      <mat-icon matSuffix (click)="togglePasswordVisibility()">{{
        showPassword$() ? 'visibility' : 'visibility_off'
      }}</mat-icon>
      <mat-hint align="end" aria-live="polite">
        {{ passwordFormControl.value.length }} / {{ max() }}
      </mat-hint>
    </mat-form-field>

    <!-- PROGRESS BAR -->
    <mat-progress-bar [color]="color()" [value]="strength$()" mode="determinate">
    </mat-progress-bar>

    <!-- CARD INFO  -->
    <mat-card>
      <mat-card-content>
        @if (enableLowerCaseLetterRule()) {
          <div class="info-row">
            @if (containAtLeastOneLowerCaseLetter()) {
              <mat-icon class="mat-icon-animated-done" color="primary">done</mat-icon>
            } @else {
              <mat-icon color="warn">error</mat-icon>
            }
            <span>Contains at least one lower character</span>
          </div>
        }
        @if (enableUpperCaseLetterRule()) {
          <div class="info-row">
            @if (containAtLeastOneUpperCaseLetter()) {
              <mat-icon class="mat-icon-animated-done" color="primary">done</mat-icon>
            } @else {
              <mat-icon class="mat-icon-animated-error" color="warn">error</mat-icon>
            }
            <span>Contains at least one upper character</span>
          </div>
        }
        @if (enableDigitRule()) {
          <div class="info-row">
            @if (containAtLeastOneDigit()) {
              <mat-icon class="mat-icon-animated-done" color="primary">done</mat-icon>
            } @else {
              <mat-icon class="mat-icon-animated-error" color="warn">error</mat-icon>
            }
            <span>Contains at least one digit character</span>
          </div>
        }
        @if (enableSpecialCharRule()) {
          <div class="info-row">
            @if (containAtLeastOneSpecialChar()) {
              <mat-icon class="mat-icon-animated-done" color="primary">done</mat-icon>
            } @else {
              <mat-icon class="mat-icon-animated-error" color="warn">error</mat-icon>
            }
            <span>Contains at least one special character</span>
          </div>
        }
        @if (enableLengthRule()) {
          <div class="info-row">
            @if (containAtLeastMinChars()) {
              <mat-icon class="mat-icon-animated-done" color="primary">done</mat-icon>
            } @else {
              <mat-icon class="mat-icon-animated-error" color="warn">error</mat-icon>
            }
            <span>Contains at least {{ min() }} characters</span>
          </div>
        }
        @if (customValidator()) {
          <div class="info-row">
            @if (containAtCustomChars()) {
              <mat-icon class="mat-icon-animated-done" color="primary">done</mat-icon>
            } @else {
              <mat-icon class="mat-icon-animated-error" color="warn">error</mat-icon>
            }
            <span>Contains at least one custom character</span>
          </div>
        }
      </mat-card-content>
    </mat-card>
    @if (enableScoreInfo()) {
      <mat-hint class="score-info" aria-live="polite">{{ strength$() }}%</mat-hint>
    }

    <mat-form-field color="primary" class="w-full mt-1">
      <mat-label>Confirm Password</mat-label>
      <input
        matInput
        formControlName="confirmPassword"
        [type]="showConfirmPassword$() ? 'text' : 'password'"
        autocomplete="current-password"
      />
      <mat-icon matSuffix (click)="toggleConfirmPasswordVisibility()">{{
        showConfirmPassword$() ? 'visibility' : 'visibility_off'
      }}</mat-icon>

      @if (passwordConfirmationFormControl.touched && passwordConfirmationFormControl.invalid) {
        <mat-error>
          <span> Your passwords do not match </span>
        </mat-error>
      }
    </mat-form-field>
  </div>
</form>
